const state = {
  orderNumber: '',
  queryPayStatus: false,
  updatePackageInfo: false
}

const mutations = {
  setOrderNumber(state, orderNumber) {
    state.orderNumber = orderNumber
  },
  setQueryPayStatus(state, status) {
    state.queryPayStatus = status
  },
  setUpdatePackageInfo(state, status) {
    state.updatePackageInfo = status
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/topup.js